import { Paper, Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const tooltipDropShadow =
    'drop-shadow(0px 5px 6px #00000033) drop-shadow(0px 3px 8px #0000001F)';

// Styled tooltip with our base styling
export const StyledTooltip = styled(Paper)({
    maxWidth: 684,
    padding: '16px 16px',
    backgroundColor: '#ffffff',
    color: '#000000',
    margin: '16px',
    borderRadius: '8px',
    boxShadow: 'none',
    position: 'relative',
    zIndex: 2,
});

const arrowBase = {
    position: 'absolute' as const,
    width: '0.71em',
    height: '0.71em',
    pointerEvents: 'none' as const,
    transform: 'rotate(45deg)',
};

// Styled popper with our complicated arrow
export const StyledPopper = styled(Popper)({
    zIndex: 1500,
    '& .tooltip-arrow': {
        ...arrowBase,
        backgroundColor: '#ffffff',
        zIndex: 1,
    },
    // top placements — arrow peeks out below the tooltip box
    '&[data-popper-placement="top"] .tooltip-arrow': {
        bottom: '-0.35em',
        left: '50%',
        marginLeft: '-0.35em',
    },
    '&[data-popper-placement="top-start"] .tooltip-arrow': {
        bottom: '-0.35em',
        left: '10%',
    },
    '&[data-popper-placement="top-end"] .tooltip-arrow': {
        bottom: '-0.35em',
        right: '10%',
    },
    // bottom placements — arrow peeks out above the tooltip box
    '&[data-popper-placement="bottom"] .tooltip-arrow': {
        top: '-0.35em',
        left: '50%',
        marginLeft: '-0.35em',
    },
    '&[data-popper-placement="bottom-start"] .tooltip-arrow': {
        top: '-0.35em',
        left: '10%',
    },
    '&[data-popper-placement="bottom-end"] .tooltip-arrow': {
        top: '-0.35em',
        right: '10%',
    },
    // left/right placements
    '&[data-popper-placement="left"] .tooltip-arrow': {
        right: '10px',
        top: '50%',
        marginTop: '-0.35em',
    },
    '&[data-popper-placement="right"] .tooltip-arrow': {
        left: '10px',
        top: '50%',
        marginTop: '-0.35em',
    },
});
